module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 016.72e93f35.jpg";